module.exports = __webpack_public_path__ + "img/opt_gl.7d954ddb.png";